/* tslint:disable */
/* eslint-disable */
/**
 * CMS
 * The CMS API description
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosResponse, AxiosInstance, AxiosRequestConfig } from "axios";
// @ts-ignore
import globalAxios from "@/config/axiosInstance";
import { Configuration } from "../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
import { Bool } from "../models";
import { CreateActionDto } from "../models";
import { DateNumber } from "../models";
import { EnumInteger } from "../models";
/**
 * ActionApi - axios parameter creator
 * @export
 */
export const ActionApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [contentKey]
     * @param {number} [userKey]
     * @param {EnumInteger} [state]
     * @param {DateNumber} [date]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionControllerGetActions: async (
      pageNumber: number,
      pageIndex: number,
      contentKey?: string,
      userKey?: number,
      state?: EnumInteger,
      date?: DateNumber,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageNumber' is not null or undefined
      if (pageNumber === null || pageNumber === undefined) {
        throw new RequiredError(
          "pageNumber",
          "Required parameter pageNumber was null or undefined when calling actionControllerGetActions."
        );
      }
      // verify required parameter 'pageIndex' is not null or undefined
      if (pageIndex === null || pageIndex === undefined) {
        throw new RequiredError(
          "pageIndex",
          "Required parameter pageIndex was null or undefined when calling actionControllerGetActions."
        );
      }
      const localVarPath = `/v1/cms/api/action/like`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageNumber !== undefined) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }

      if (pageIndex !== undefined) {
        localVarQueryParameter["pageIndex"] = pageIndex;
      }

      if (contentKey !== undefined) {
        localVarQueryParameter["contentKey"] = contentKey;
      }

      if (userKey !== undefined) {
        localVarQueryParameter["userKey"] = userKey;
      }

      if (state !== undefined) {
        localVarQueryParameter["state"] = state;
      }

      if (date !== undefined) {
        localVarQueryParameter["date"] = date;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionControllerGetBookmark: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/cms/api/action/bookmark`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [contentKey]
     * @param {number} [userKey]
     * @param {EnumInteger} [state]
     * @param {DateNumber} [date]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionControllerGetDislikes: async (
      pageNumber: number,
      pageIndex: number,
      contentKey?: string,
      userKey?: number,
      state?: EnumInteger,
      date?: DateNumber,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageNumber' is not null or undefined
      if (pageNumber === null || pageNumber === undefined) {
        throw new RequiredError(
          "pageNumber",
          "Required parameter pageNumber was null or undefined when calling actionControllerGetDislikes."
        );
      }
      // verify required parameter 'pageIndex' is not null or undefined
      if (pageIndex === null || pageIndex === undefined) {
        throw new RequiredError(
          "pageIndex",
          "Required parameter pageIndex was null or undefined when calling actionControllerGetDislikes."
        );
      }
      const localVarPath = `/v1/cms/api/action/dislike`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageNumber !== undefined) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }

      if (pageIndex !== undefined) {
        localVarQueryParameter["pageIndex"] = pageIndex;
      }

      if (contentKey !== undefined) {
        localVarQueryParameter["contentKey"] = contentKey;
      }

      if (userKey !== undefined) {
        localVarQueryParameter["userKey"] = userKey;
      }

      if (state !== undefined) {
        localVarQueryParameter["state"] = state;
      }

      if (date !== undefined) {
        localVarQueryParameter["date"] = date;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [contentKey]
     * @param {Bool} [isEpisode]
     * @param {number} [season]
     * @param {number} [episode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionControllerGetPostActionsByUser: async (
      contentKey?: string,
      isEpisode?: Bool,
      season?: number,
      episode?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/cms/api/action/content`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (contentKey !== undefined) {
        localVarQueryParameter["contentKey"] = contentKey;
      }

      if (isEpisode !== undefined) {
        localVarQueryParameter["isEpisode"] = isEpisode;
      }

      if (season !== undefined) {
        localVarQueryParameter["season"] = season;
      }

      if (episode !== undefined) {
        localVarQueryParameter["episode"] = episode;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionControllerGetWatchData: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/cms/api/action/watch-tracker`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionControllerGetWatchEvents: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/cms/api/action/watch`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionControllerInsertBookmark: async (
      body: CreateActionDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling actionControllerInsertBookmark."
        );
      }
      const localVarPath = `/v1/cms/api/action/bookmark`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionControllerInsertDislike: async (
      body: CreateActionDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling actionControllerInsertDislike."
        );
      }
      const localVarPath = `/v1/cms/api/action/dislike`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionControllerInsertLike: async (
      body: CreateActionDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling actionControllerInsertLike."
        );
      }
      const localVarPath = `/v1/cms/api/action/like`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionControllerInsertWatchData: async (
      body: CreateActionDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling actionControllerInsertWatchData."
        );
      }
      const localVarPath = `/v1/cms/api/action/watch-tracker`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionControllerInsertWatchEvent: async (
      body: CreateActionDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling actionControllerInsertWatchEvent."
        );
      }
      const localVarPath = `/v1/cms/api/action/watch`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionControllerRemoveBookmark: async (
      body: CreateActionDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling actionControllerRemoveBookmark."
        );
      }
      const localVarPath = `/v1/cms/api/action/bookmark`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ActionApi - functional programming interface
 * @export
 */
export const ActionApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [contentKey]
     * @param {number} [userKey]
     * @param {EnumInteger} [state]
     * @param {DateNumber} [date]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerGetActions(
      pageNumber: number,
      pageIndex: number,
      contentKey?: string,
      userKey?: number,
      state?: EnumInteger,
      date?: DateNumber,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ActionApiAxiosParamCreator(
        configuration
      ).actionControllerGetActions(
        pageNumber,
        pageIndex,
        contentKey,
        userKey,
        state,
        date,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerGetBookmark(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ActionApiAxiosParamCreator(
        configuration
      ).actionControllerGetBookmark(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [contentKey]
     * @param {number} [userKey]
     * @param {EnumInteger} [state]
     * @param {DateNumber} [date]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerGetDislikes(
      pageNumber: number,
      pageIndex: number,
      contentKey?: string,
      userKey?: number,
      state?: EnumInteger,
      date?: DateNumber,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ActionApiAxiosParamCreator(
        configuration
      ).actionControllerGetDislikes(
        pageNumber,
        pageIndex,
        contentKey,
        userKey,
        state,
        date,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} [contentKey]
     * @param {Bool} [isEpisode]
     * @param {number} [season]
     * @param {number} [episode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerGetPostActionsByUser(
      contentKey?: string,
      isEpisode?: Bool,
      season?: number,
      episode?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ActionApiAxiosParamCreator(
        configuration
      ).actionControllerGetPostActionsByUser(
        contentKey,
        isEpisode,
        season,
        episode,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerGetWatchData(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ActionApiAxiosParamCreator(
        configuration
      ).actionControllerGetWatchData(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerGetWatchEvents(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ActionApiAxiosParamCreator(
        configuration
      ).actionControllerGetWatchEvents(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerInsertBookmark(
      body: CreateActionDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ActionApiAxiosParamCreator(
        configuration
      ).actionControllerInsertBookmark(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerInsertDislike(
      body: CreateActionDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ActionApiAxiosParamCreator(
        configuration
      ).actionControllerInsertDislike(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerInsertLike(
      body: CreateActionDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ActionApiAxiosParamCreator(
        configuration
      ).actionControllerInsertLike(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerInsertWatchData(
      body: CreateActionDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ActionApiAxiosParamCreator(
        configuration
      ).actionControllerInsertWatchData(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerInsertWatchEvent(
      body: CreateActionDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ActionApiAxiosParamCreator(
        configuration
      ).actionControllerInsertWatchEvent(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerRemoveBookmark(
      body: CreateActionDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ActionApiAxiosParamCreator(
        configuration
      ).actionControllerRemoveBookmark(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * ActionApi - factory interface
 * @export
 */
export const ActionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [contentKey]
     * @param {number} [userKey]
     * @param {EnumInteger} [state]
     * @param {DateNumber} [date]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerGetActions(
      pageNumber: number,
      pageIndex: number,
      contentKey?: string,
      userKey?: number,
      state?: EnumInteger,
      date?: DateNumber,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ActionApiFp(configuration)
        .actionControllerGetActions(
          pageNumber,
          pageIndex,
          contentKey,
          userKey,
          state,
          date,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerGetBookmark(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ActionApiFp(configuration)
        .actionControllerGetBookmark(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [contentKey]
     * @param {number} [userKey]
     * @param {EnumInteger} [state]
     * @param {DateNumber} [date]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerGetDislikes(
      pageNumber: number,
      pageIndex: number,
      contentKey?: string,
      userKey?: number,
      state?: EnumInteger,
      date?: DateNumber,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ActionApiFp(configuration)
        .actionControllerGetDislikes(
          pageNumber,
          pageIndex,
          contentKey,
          userKey,
          state,
          date,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [contentKey]
     * @param {Bool} [isEpisode]
     * @param {number} [season]
     * @param {number} [episode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerGetPostActionsByUser(
      contentKey?: string,
      isEpisode?: Bool,
      season?: number,
      episode?: number,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ActionApiFp(configuration)
        .actionControllerGetPostActionsByUser(
          contentKey,
          isEpisode,
          season,
          episode,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerGetWatchData(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ActionApiFp(configuration)
        .actionControllerGetWatchData(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerGetWatchEvents(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ActionApiFp(configuration)
        .actionControllerGetWatchEvents(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerInsertBookmark(
      body: CreateActionDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ActionApiFp(configuration)
        .actionControllerInsertBookmark(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerInsertDislike(
      body: CreateActionDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ActionApiFp(configuration)
        .actionControllerInsertDislike(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerInsertLike(
      body: CreateActionDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ActionApiFp(configuration)
        .actionControllerInsertLike(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerInsertWatchData(
      body: CreateActionDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ActionApiFp(configuration)
        .actionControllerInsertWatchData(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerInsertWatchEvent(
      body: CreateActionDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ActionApiFp(configuration)
        .actionControllerInsertWatchEvent(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateActionDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionControllerRemoveBookmark(
      body: CreateActionDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ActionApiFp(configuration)
        .actionControllerRemoveBookmark(body, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ActionApi - object-oriented interface
 * @export
 * @class ActionApi
 * @extends {BaseAPI}
 */
export class ActionApi extends BaseAPI {
  /**
   *
   * @param {number} pageNumber
   * @param {number} pageIndex
   * @param {string} [contentKey]
   * @param {number} [userKey]
   * @param {EnumInteger} [state]
   * @param {DateNumber} [date]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActionApi
   */
  public async actionControllerGetActions(
    pageNumber: number,
    pageIndex: number,
    contentKey?: string,
    userKey?: number,
    state?: EnumInteger,
    date?: DateNumber,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ActionApiFp(this.configuration)
      .actionControllerGetActions(
        pageNumber,
        pageIndex,
        contentKey,
        userKey,
        state,
        date,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActionApi
   */
  public async actionControllerGetBookmark(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ActionApiFp(this.configuration)
      .actionControllerGetBookmark(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {number} pageNumber
   * @param {number} pageIndex
   * @param {string} [contentKey]
   * @param {number} [userKey]
   * @param {EnumInteger} [state]
   * @param {DateNumber} [date]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActionApi
   */
  public async actionControllerGetDislikes(
    pageNumber: number,
    pageIndex: number,
    contentKey?: string,
    userKey?: number,
    state?: EnumInteger,
    date?: DateNumber,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ActionApiFp(this.configuration)
      .actionControllerGetDislikes(
        pageNumber,
        pageIndex,
        contentKey,
        userKey,
        state,
        date,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} [contentKey]
   * @param {Bool} [isEpisode]
   * @param {number} [season]
   * @param {number} [episode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActionApi
   */
  public async actionControllerGetPostActionsByUser(
    contentKey?: string,
    isEpisode?: Bool,
    season?: number,
    episode?: number,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ActionApiFp(this.configuration)
      .actionControllerGetPostActionsByUser(
        contentKey,
        isEpisode,
        season,
        episode,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActionApi
   */
  public async actionControllerGetWatchData(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ActionApiFp(this.configuration)
      .actionControllerGetWatchData(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActionApi
   */
  public async actionControllerGetWatchEvents(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ActionApiFp(this.configuration)
      .actionControllerGetWatchEvents(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {CreateActionDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActionApi
   */
  public async actionControllerInsertBookmark(
    body: CreateActionDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ActionApiFp(this.configuration)
      .actionControllerInsertBookmark(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {CreateActionDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActionApi
   */
  public async actionControllerInsertDislike(
    body: CreateActionDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ActionApiFp(this.configuration)
      .actionControllerInsertDislike(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {CreateActionDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActionApi
   */
  public async actionControllerInsertLike(
    body: CreateActionDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ActionApiFp(this.configuration)
      .actionControllerInsertLike(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {CreateActionDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActionApi
   */
  public async actionControllerInsertWatchData(
    body: CreateActionDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ActionApiFp(this.configuration)
      .actionControllerInsertWatchData(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {CreateActionDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActionApi
   */
  public async actionControllerInsertWatchEvent(
    body: CreateActionDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ActionApiFp(this.configuration)
      .actionControllerInsertWatchEvent(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {CreateActionDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActionApi
   */
  public async actionControllerRemoveBookmark(
    body: CreateActionDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ActionApiFp(this.configuration)
      .actionControllerRemoveBookmark(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
